import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { getCropPrices, IGetCropPrices, IGetCropPricesParams } from '../../../api/crop-trends/getCropPrices';

export const useGetCropPrices = ({ searchParam }: IGetCropPricesParams) => {
  return useQuery<IGetCropPrices[], AxiosError>(['crop-prices', searchParam.wholesaleMarketCode], () =>
    getCropPrices({ searchParam }),
  );
};
